import { RankingData } from "#next/utils/explorer/generateRankings";
import { GraphMode, SearchResult } from "#next/utils/interfaces";
import _ from "lodash";
import { DateTime } from "luxon";
import {
  TTabNames,
  GraphType,
  filterToFieldNameMap,
  languageArray,
  toYYYYMMDD,
  SummaryViewerSeriesData,
} from "#next/utils/explorer/shared";

export const summarizeGraphSeriesData = (searchResults: SearchResult[]) => {
  const datesOfSearchResults = [
    ...new Set(
      searchResults.map((post) => {
        const date = new Date(post.timestamp);
        return toYYYYMMDD(date);
      }),
    ),
  ];
  const datesAndCountsOfValue = datesOfSearchResults.map((date) => {
    const searchResultsOnDate = searchResults.filter((post) => {
      const postDate = new Date(post.timestamp);
      return toYYYYMMDD(postDate) === date;
    });
    return [
      DateTime.fromFormat(date, "yyyy-MM-dd").toMillis(),
      searchResultsOnDate.length,
    ];
  });
  return datesAndCountsOfValue.sort((a, b) => {
    if (a.length === 0 || a[0] === undefined) return -1;
    if (b.length === 0 || b[0] === undefined) return 1;
    else return a[0] < b[0] ? -1 : 1;
  }) as [number, number][]; // I'm not sure why this is necessary, but typescript is complaining about the type if this isn't specified
};

export const generateGraphData = (
  posts: SearchResult[],
  rankData: RankingData[],
  activeTab: TTabNames,
  graphMode: GraphMode,
  graphType: GraphType,
  filterValue: string | null,
) => {
  const summary: Record<string, number[][]> = {};
  const searchResults: SearchResult[] = posts;
  const seriesData =
    graphMode === GraphMode.language
      ? languageArray
      : rankData.map((item) => item.name);
  const key = filterToFieldNameMap[activeTab];

  if (graphMode === GraphMode.platform) {
    seriesData.forEach((value) => {
      const searchResultsWithValue = searchResults.filter((post) => {
        const fieldValueOfPost = post[key as keyof SearchResult];
        if (Array.isArray(fieldValueOfPost)) {
          return fieldValueOfPost.includes(value);
        } else {
          return fieldValueOfPost === value;
        }
      });
      summary[value] = summarizeGraphSeriesData(searchResultsWithValue);
    });
  } else {
    languageArray.forEach((value) => {
      const searchResultsWithHighLanguage = searchResults.filter((post) => {
        if (value === "negative") {
          return _.get(post, value) >= 0.9;
        } else {
          return _.get(post, value) >= 0.7;
        }
      });
      summary[value] = summarizeGraphSeriesData(searchResultsWithHighLanguage);
    });
  }

  const result: SummaryViewerSeriesData[] = Object.keys(summary).map(
    (series) => {
      return {
        name: series,
        data: summary[series] as [number, number][],
        type: graphType,
        visible:
          graphMode !== "platform" || !filterValue || filterValue === series
            ? true
            : false,
      };
    },
  );

  return result;
};
